import {scopedHandler} from 'utils/redux';
import ns from './namespace';
import initState from './state';
import * as actions from './actions';
import * as effects from './effects';
import {decorateHandler as lifecycle} from 'fragments/lifecycle';

const handler = scopedHandler(ns, (state = initState, fullState, {type, payload}) => {
	switch (type) {
		case actions.initialize.type: {
			return [state, effects.initialize()];
		}

		case actions.destroy.type: {
			return [initState, null];
		}

		case actions.fetchMore.type: {
			const newState = {
				...state,
				fetchingMore: true,
				logsQuery: {...state.logsQuery, _page: state.logsPagination.currentPage + 1},
			};

			return [newState, effects.updateLogs()];
		}

		case actions.searchLogs.type: {
			const newState = {
				...state,
				logs: [],
				logsQuery: {_page: 1, ...payload},
				logsLoading: true,
			};

			return [newState, effects.updateLogs(false)];
		}

		case actions.searchUsers.type: {
			return [state, effects.searchUsers(payload)];
		}

		case actions.searchBuildings.type: {
			return [state, effects.searchBuildings(payload)];
		}

		case actions.setLogModel.type: {
			const newState = {
				...state,
				logs: [],
				logsQuery: {_page: 1, logModel: payload},
				logsLoading: true,
			};

			return [newState, effects.updateLogs(true)];
		}

		case actions._setLogs.type: {
			const newState = {
				...state,
				logs: [...state.logs, ...payload.data],
				logsPagination: payload.pagination,
				logsLoading: false,
				fetchingMore: false,
			};

			return [newState, null];
		}

		case actions._updateLogsQuery.type: {
			const newState = {
				...state,
				logsQuery: {...state.logsQuery, ...payload},
			};

			return [newState, null];
		}

		case actions._setOrganizations.type: {
			return [{...state, organizations: payload}, null];
		}

		case actions._setTeams.type: {
			return [{...state, teams: payload}, null];
		}

		case actions._initialize.type: {
			return [{...state, initialized: true}];
		}

		default:
			return [state, null];
	}
});

export default lifecycle({
	namespace: ns,
	initializeType: actions.initialize.type,
	destroyType: actions.destroy.type,
})(handler);
